<template>
    <div class="vipday-wrap">
        <h3>会员日配置</h3>
        <el-form :model="form" label-width="120px">
<!--            <el-form-item label="开始时间" >-->
<!--                <el-date-picker-->
<!--                        v-model=form.startTime-->
<!--                        type="datetime"-->
<!--                        format="yyyy-MM-dd HH:mm:ss"-->
<!--                        placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="结束时间" >-->
<!--                <el-date-picker-->
<!--                        v-model=form.endTime-->
<!--                        type="datetime"-->
<!--                        format="yyyy-MM-dd HH:mm:ss"-->
<!--                        placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--            </el-form-item>-->
            <el-form-item label="每周几">
                <el-select v-model="form.weekIndex" filterable  placeholder="每周几">
                    <el-option label="周一" value="1"></el-option>
                    <el-option label="周二" value="2"></el-option>
                    <el-option label="周三" value="3"></el-option>
                    <el-option label="周四" value="4"></el-option>
                    <el-option label="周五" value="5"></el-option>
                    <el-option label="周六" value="6"></el-option>
                    <el-option label="周日" value="7"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否启用" >
                <el-switch
                        v-model="form.isEffective"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer center-wrap">
            <el-button type="primary" @click="setVipDay">提交保存</el-button>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getVipDayInfo,setVipDayInfo} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                loading:true,
                selectValue: '',
                dialogFormVisible:false,
                form: {
                    // startTime: "",
                    // endTime: "",
                    isEffective: "",
                    weekIndex:""
                }
            }
        },
        //挂载时候执行
        mounted(){
            //获取查询条件下拉列表
            getVipDayInfo({}).then((res) => {
                if(res.data.value){
                    var _data = res.data.value;
                    // _data.startTime = new Date(_data.startTime);
                    // _data.endTime = new Date(_data.endTime);
                    this.form = _data;
                }

            })
        },
        methods:{
            setVipDay(){
                let _this = this;
                // this.form.startTime = Date.parse(this.form.startTime);
                // this.form.endTime = Date.parse(this.form.endTime);
                setVipDayInfo(this.form).then((res) => {
                    if(res.data.status==200){
                        _this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    }else{
                        _this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>
<style scoped lang="scss" rel="stylesheet/scss">
    .vipday-wrap{
        padding: 20px;
        h3{
            text-align: center;
        }
        .center-wrap{
            text-align: center;
        }
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner,.el-input-number, .el-select{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/vip/vipDay.vue